export default {
  yourUpdates: 'Your updates',
}
